/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Order} from './Order';
import {OrdersIndexPagination} from './OrdersIndexPagination';

/**
 * The OrdersIndex model module.
 * @module model/OrdersIndex
 * @version v1
 */
export class OrdersIndex {
  /**
   * Constructs a new <code>OrdersIndex</code>.
   * @alias module:model/OrdersIndex
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OrdersIndex</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OrdersIndex} obj Optional instance to populate.
   * @return {module:model/OrdersIndex} The populated <code>OrdersIndex</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OrdersIndex();
      if (data.hasOwnProperty('orders'))
        obj.orders = ApiClient.convertToType(data['orders'], [Order]);
      if (data.hasOwnProperty('pagination'))
        obj.pagination = OrdersIndexPagination.constructFromObject(data['pagination']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/Order>} orders
 */
OrdersIndex.prototype.orders = undefined;

/**
 * @member {module:model/OrdersIndexPagination} pagination
 */
OrdersIndex.prototype.pagination = undefined;

